import * as React from 'react';

function SvgTickInCircle(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.95 11.354a.45.45 0 11.63.642l-7.374 7.25a.45.45 0 01-.63 0l-3.156-3.1a.45.45 0 11.63-.642l2.84 2.79 7.06-6.94z"
        fill="#414B56"
      />
      <circle cx={15} cy={15} r={10.5} stroke="#414B56" />
    </svg>
  );
}

export default SvgTickInCircle;
